<template>
  <div>
    <div
      ref='wrapper'
      class='relative flex items-center'
      :class="opened ? 'z-[calc(var(--z-panel)+1)] cursor-default' : 'cursor-pointer'"
      @click="activate">
      <div
          @keydown.esc.stop='handleKeyDown'
          tabindex="0"
          class='outline-0'>
        <div
          class="flex items-center"
          :class="disabled ? 'cursor-default' : 'cursor-pointer'"
          @mouseenter="activate"
          ref='header'
        >
          <slot name="wrapper"></slot>
        </div>
        <div
          class="fixed top-12 bottom-0 left-0 z-(--z-panel) w-60.5 overflow-y-hidden transition-transform duration-150
                 max-sm:top-0 max-sm:bottom-0"
          :class="opened ? 'translate-x-0' : '-translate-x-75'"
        >
          <div
            class="absolute inset-y-0 box-border flex size-full flex-col border-r border-line bg-chrome pb-2
                   shadow-[1px_1px_8px_var(--shadow-color)]
                   [backdrop-filter:var(--glass-blur)] [-webkit-backdrop-filter:var(--glass-blur)]"
          >
            <div
              @click.stop='dropContentClick'
              class="flex min-h-0 flex-1 flex-col"
            >
              <slot name="items" @close="() => close()"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="opened"
      class="fixed inset-x-0 top-12 bottom-0 z-(--z-panel) bg-backdrop max-sm:top-0"
      @click="close()">
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';

const props = defineProps({
  items: Array,
  type: {
    type: String,
    default: '',
  },
  closeByEscape: {
    type: Boolean,
    default: true,
  },
  target: {
    type: String,
    default: '',
  },
  stickRight: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['open', 'closed', 'visibilityChanged', 'update:opened']);

const wrapper = ref(null);
const header = ref(null);

const dropId = ref(null);
const opened = ref(false);
const width = ref(0);
const height = ref(0);
const needStickTop = ref(false);
const headerRect = ref({
  top: 0,
  left: 0,
  bottom: 0,
});

onMounted(() => {
  dropId.value = window.utils.genId();
});

const close = () => {
  opened.value = false;
  emit('closed');
  emit('visibilityChanged', false);
};

const handleKeyDown = () => {
  if (props.closeByEscape) {
    close();
  }
};

const dropContentClick = (ev) => {
  if (ev.target.closest('.archive__title')) {
    return;
  }
  close(new Event('click'));
};

const activate = (e) => {
  if (props.disabled) {
    return;
  }

  headerRect.value = header.value.getBoundingClientRect();
  width.value = wrapper.value.offsetWidth;
  height.value = wrapper.value.offsetHeight;
  if (window.innerHeight - 300 - headerRect.value.bottom <= 0) {
    needStickTop.value = true;
  } else {
    needStickTop.value = false;
  }
  if (e.type !== 'click') {
    return;
  }
  if (!opened.value) {
    opened.value = true;
  } else {
    opened.value = false;
  }
  emit('open');
  emit('visibilityChanged', true);
};

watch(opened, () => {
  emit('update:opened', opened.value);
});
</script>

